const common = require('angular').module('oly.common');

const { formDirectiveDefinition, ngFormDirectiveDefinition } = require('./form.directive');
const { DeliveryFormControlState } = require('./delivery-form-control.state');

common.service('DeliveryFormControlState', DeliveryFormControlState);

common.directive('form', formDirectiveDefinition)
    .directive('ngForm', ngFormDirectiveDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/form/index.js